module.exports = __webpack_public_path__ + "static/media/9.c81d3b49.jpg";